import React from 'react';
import Post from '../../Post';
import Spacing from '../../Spacing';
import { useEffect, useState } from 'react';
import { getBlog } from '../../../service/api';
import dayjs from 'dayjs';
import { previewAssetUrl } from '../../../helpers';

export default function BlogSectionStyle2() {
  const [blogData, setBlogData] = useState();
  const [page, setPage] = useState(1);
  const limit = 9;

  const fetchBlog = async (pageNum = 1) => {
    try {
      const res = await getBlog({
        filter: {},
        page: pageNum,
        limit,
        sort: { createdAt: '-1' },
      });
      setBlogData(res?.data);
    } catch (err) {
      setBlogData({ docs: [], totalPages: 1, page: 1 });
    }
  };

  useEffect(() => {
    fetchBlog(page);
  }, [page]);

  return (
    <div className='container'>
      <div className='row cs_row_gap_50'>
        {blogData?.docs.map((item, index) => {
          const postProps = {
            title: item.title,
            thumbUrl: previewAssetUrl(item.assetId),
            date: dayjs(item.createdAt).format('DD/MM/YYYY'),
            href: `/blog/${item.id}`,
            socialShare: true,
          };
          return (
            <div className='col-xl-4 col-md-6' key={index}>
              <Post {...postProps} />
            </div>
          );
        })}
      </div>
      {blogData?.docs?.length === 0 && (
        <div className='text-center cs_fs_18'>Chưa có bài viết nào</div>
      )}
      {blogData?.docs?.length > 0 && (
      <>
      <Spacing md='110' lg='70' />
      <ul className='cs_pagination_box'>
        <li>
          <button
            className='cs_pagination_arrow cs_center'
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            <img src='images/icons/left_arrow_blue.svg' alt='Icon' />
          </button>
        </li>
        {Array.from({ length: blogData?.totalPages || 1 }, (_, i) => i + 1).map(
          (p) => (
            <li key={p}>
              <button
                className={`cs_pagination_item cs_center${
                  page === p ? ' active' : ''
                }`}
                onClick={() => setPage(p)}
              >
                {p}
              </button>
            </li>
          )
        )}
        <li>
          <button
            className='cs_pagination_arrow cs_center'
            disabled={page === (blogData?.totalPages || 1)}
            onClick={() => setPage(page + 1)}
          >
            <img src='images/icons/right_arrow_blue.svg' alt='Icon' />
          </button>
        </li>
      </ul>
      </>
      )}
    </div>
  );
}
